import React, { useMemo, useState } from "react";
import { useRecoilValue } from "recoil";

import { useConfig } from "src/hooks/config";
import Money from "src/common/components/money";
import { getBetCalculations } from "calculation";
import upperDataStore from "src/stores/upperData";
import selectionsStore from "src/stores/selections";
import { useTranslation } from "src/hooks/translation";
import { useOutSideClick } from "src/hooks/outSideClick";
import { BetCalculationsEnum } from "src/constants/enums/betCalculations";
import mainStore from "src/stores/main";
import { BetTypeEnum } from "src/constants/enums/betType";

interface IProps {
  stake: number;
}

const BetDetailsBonus = ({ stake }: IProps) => {
  const t = useTranslation();
  const config = useConfig();
  const { bonusRules } = useRecoilValue(upperDataStore);
  const { selections } = useRecoilValue(selectionsStore);
  const { partnerConfig, currencyConfig } = useRecoilValue(upperDataStore);

  const { betType, profitBoostPercent } = useRecoilValue(mainStore);
  const [isOpen, setIsOpen] = useState(false);

  const filtredBonusRules = bonusRules.filter(item => !item.ExactLosing && item.Basis).sort((a, b) => a.AmountPercent - b.AmountPercent);

  const popupRef = useOutSideClick(
    e => {
      if (isOpen) {
        e.stopPropagation();
        setIsOpen(false);
      }
    },
    [isOpen]
  );

  const {
    expressBonus: { amount, percent, isMax },
  } = useMemo(
    () =>
      getBetCalculations([BetCalculationsEnum.Bonus], {
        config,
        partnerConfig,
        stake,
        events: selections,
        bonusRule: filtredBonusRules,
        currencyConfig,
      }),
    [config, partnerConfig, stake, currencyConfig, selections, filtredBonusRules]
  );

  if (betType !== BetTypeEnum.Multiple || !filtredBonusRules.length || !amount) return null;

  return (
    <div className="B-betslip-bet-details-info-row Bonus">
      <p className="B-info-row-title">
        {t("Bonus:")}
        <span className="B-percent">{percent}%</span>
        <span
          className="B-info-icon global-icon icon-circle-info"
          onMouseDown={() => setIsOpen(true)}
        />
      </p>

      <p className={`B-info-row-number ${isMax && 'B-max-bonus'}`}>
        <Money amount={amount} />
        {isMax && <span className="B-max-bonus-txt">{`${t("Max bonus")}`}</span>}
      </p>

      {isOpen && (
        <div className="bonus-rules-popup" ref={popupRef}>
          <div>
            <span>{t("Bonus")}</span>
            <span>{t("Count")}</span>
            <span>{t("Min odds")}</span>
            <span>{t('Min Bet Amount')}</span>
            <span>{t("Max Bonus Amount")}</span>
          </div>

          {filtredBonusRules.map((item, index) => {
            const { MaxBonusAmount, Amount } = item?.MinBetStakes?.MinStakes?.[0] || {};
            return (
              <div key={index}>
                <span>{item.AmountPercent + " %"}</span>
                <span>
                  {item.MaximumSelections === item.MinimumSelections
                    ? item.MaximumSelections
                    : `${item.MinimumSelections} ${item.MaximumSelections
                      ? item.MaximumSelections
                      : t("and over")
                    }`}
                </span>
                <span>{item.MinOdds}</span>
                <span> {Amount || '-'} </span>
                <span> {MaxBonusAmount || '-'} </span>
              </div>
            )
          })}
        </div>
      )}
    </div>
  );
};

export default BetDetailsBonus;
